import { call, put, takeEvery } from 'redux-saga/effects';
import RequestMiddlewarePipeline from '../../../../../boilerplate/redux/RequestMiddlewarePipeline';
import AfCoreRequest from '../../../../bootstrap/redux-data/AfCoreRequest';
import {
	addTagWidgetEntries, setTagWidgetErrors, TAG_WIDGET_FETCH_ENTRIES,
} from './tagWidgetActions';

/**
 * Fetch entry list
 */
function* fetchTagWidgets(action: any) {
	const afCoreRequest = new AfCoreRequest(action.queryKey);

	try {
		const response = yield call((): Promise<RequestMiddlewarePipeline> => {
			return afCoreRequest.getRequest({ 
				url: '/api/public/v1/widgets/tags',
				params: action.params,
			} as IRequestObject);
		});

		yield put(addTagWidgetEntries(
			action.queryKey,
			response.getContent('content'),
			response.getMetaData(),
			action.options,
		));
	} catch (e) {
		yield put(setTagWidgetErrors(action.queryKey, e));
	}
}

export function* tagWidgetSaga() {
	yield takeEvery(TAG_WIDGET_FETCH_ENTRIES, fetchTagWidgets);
}
